import element from "../../../images/element.png";
import icon from "../../../images/selection.png";

export default function Selection() {
  return (
    <div
      className="w-full min-h-[580px] pb-10 md:pb-0 relative "
      style={{ backgroundColor: "#E9EBFE" }}
    >
     
      <img
        src={element}
        alt="Notepad Icon"
        className="absolute top-[-80px] left-10 w-[200px] md:w-[250px]"
      />

   
      <div className="container mx-auto md:px-0 pt-20 md:pt-[140px]">
      
        <div className="flex flex-col md:flex-row items-center md:items-start justify-center gap-6 md:gap-8">
          
          <h3
            className="text-blue-500 text-3xl mt-10 md:mt-0 md:text-5xl font-bold md:tracking-widest text-center md:text-left w-full md:w-[18%]"
            style={{ fontFamily: "Montserrat" }}
          >
            Selection Process
          </h3>

          
          <div className="flex flex-col md:flex-row justify-center md:ml-12 md:justify-start items-center md:items-start gap-6 w-full md:w-[60%]">
           
            <div className="flex items-start bg-white rounded-xl p-6 w-full max-w-md md:w-[380px] shadow-md relative transition-tranform hover:scale-105">
             
              <div className="min-w-[50px] h-[50px] md:min-w-[86px] md:h-[88px] rounded-full flex items-center absolute md:left-[-50px] left-4 top-[-25px] md:top-3 justify-center mr-4 p-2">
                <img src={icon} alt="Icon" className="w-full h-full" />
              </div>
              <p className="text-gray-600 italic w-full md:w-[300px] md:ml-10 ml-0 text-center md:text-left mt-4 md:mt-0" style={{ fontFamily: "Poppins" }}>
                Selection will be based on the business idea, its scalability, and the issue it addresses.
              </p>
            </div>

            <div className="flex items-start bg-white md:ml-9 rounded-xl p-6 w-full max-w-md md:w-[380px] shadow-md relative transition-transform hover:scale-105">
            
              <div className="min-w-[50px] h-[50px] md:min-w-[86px] md:h-[88px] rounded-full flex items-center absolute md:left-[-50px] left-4 top-[-25px] md:top-3 justify-center mr-4  p-2">
                <img src={icon} alt="Icon" className="w-full h-full" />
              </div>
              <p className="text-gray-600 italic w-full md:w-[250px] md:ml-10 ml-0 text-center md:text-left mt-4 md:mt-0" style={{ fontFamily: "Poppins" }} >
                Venture capitalists will evaluate and thoroughly review the
                submitted ideas.
              </p>
            </div>
          </div>
        </div>

       
        <div className="mt-12 md:mt-[50px] px-0 w-full">
          <div className="flex items-center justify-between w-full ">
            <div className="h-[2px] bg-black flex-1 mr-4"></div>
            <div className="text-2xl md:text-3xl font-semibold whitespace-nowrap text-center px-2" style={{ fontFamily: "Montserrat" }}>
              How to Register? 🚀
            </div>
            <div className="h-[2px] bg-black flex-1 ml-4"></div>
          </div>

          
          <div className="flex flex-col md:flex-row items-center mt-8 md:mt-10 justify-center gap-6 md:gap-6 px-4">
           
            <div className="bg-white rounded-xl p-6 w-full max-w-sm md:w-[360px] text-center shadow-md relative transition-tranform hover:scale-105">
              <div className="w-10 h-10 absolute top-[-16px] left-1/2 transform -translate-x-1/2 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center mx-auto mb-4">
                1
              </div>
              <h4 className="text-blue-600 font-semibold text-lg mb-2 p-2" style={{ fontFamily: "Montserrat" }}>Check Eligibility</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "Poppins" }}>
                Have any 2: SkillSphere Report (Mandatory), Next Gen Innovators Certificate, or Club Enrollment.
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 w-full max-w-sm md:w-[360px] text-center shadow-md relative transition-tranform hover:scale-105">
              <div className="w-10 h-10 absolute top-[-16px] left-1/2 transform -translate-x-1/2 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center mx-auto mb-4">
                2
              </div>
              <h4 className="text-blue-600 font-semibold text-lg mb-2 p-2" style={{ fontFamily: "Montserrat" }}>Submit Application</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "Poppins" }}>
                Upload a 2-min video explaining your idea and a detailed proposal with revenue model & impact.
              </p>
            </div>

         
            <div className="bg-white rounded-xl p-6 w-full max-w-sm md:w-[360px] text-center shadow-md relative transition-tranform hover:scale-105">
              <div className="w-10 h-10 absolute top-[-16px] left-1/2 transform -translate-x-1/2 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center mx-auto mb-4">
                3
              </div>
              <h4 className="text-blue-600 font-semibold text-lg mb-2 p-2" style={{ fontFamily: "Montserrat" }}>Selection & Evaluation</h4>
              <p className="text-gray-600 text-sm" style={{ fontFamily: "Poppins" }}>
                If shortlisted, present your idea and attend an interview with industry mentors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}